import { render, staticRenderFns } from "./switchProfile.vue?vue&type=template&id=ffb28892&scoped=true&"
import script from "./switchProfile.vue?vue&type=script&lang=js&"
export * from "./switchProfile.vue?vue&type=script&lang=js&"
import style0 from "./switchProfile.vue?vue&type=style&index=0&id=ffb28892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb28892",
  null
  
)

export default component.exports